import {
  GitHub as GithubIcon,
  LinkedIn as LinkedInIcon,
  Email as EmailIcon
} from '@material-ui/icons';

export const footerContacts = [
  {
    name: 'Github',
    title: 'Click to view my github account',
    link: 'https://github.com/LucasFelipeTimoteo',
    icon: <GithubIcon />
  },

  {
    name: 'LinkedIn',
    title: 'Click to view my github account',
    link: 'https://www.linkedin.com/in/lucas-felipe-2b314a150/',
    icon: <LinkedInIcon />
  },

  {
    name: 'Email',
    title: 'My E-mail: lucasfelipetimoteo@gmail.com',
    link: 'mailto:lucasfelipetimoteo@gmail.com',
    icon: <EmailIcon />
  }
]